import {Act} from './Act';

/**
 * Use ParallelAct as container for parallel Acts.
 * It is Promise.all() like behaviour.
 */
export class ParallelAct extends Act {
    private _activeActs: Act[] = [];

    public async skip(): Promise<void> {
        if (this._activeActs.length > 0) {
            return Promise.all(this._activeActs.map(act => {
                return act.skip();
            })).then(() => {
                return;
            });
        } else {
            return;
        }
    }

    public async forceSkip(): Promise<void> {
        if (this._activeActs.length > 0) {
            return Promise.all(this._activeActs.map(act => {
                return act.forceSkip();
            })).then(() => {
                return;
            });
        } else {
            return;
        }
    }

    protected async executeInternal(): Promise<void> {
        if (this._activeActs.length > 0 ) {
            await this.executeActiveActs();
        }
    }

    protected async executeActiveActs(): Promise<void | undefined> {
        const promises = this._activeActs
            .map(act => new Promise(res => {
                if (this.executeSkipOnRoot) {
                    act.executeSkipOnRoot = this.executeSkipOnRoot;
                    act.execute(() => res(undefined));
                }
            }));

        await Promise.all(promises);
    }

    public dispose(): void {
        super.dispose();

        this._activeActs.forEach(act => {
            act.dispose();
        });
        this._activeActs = [];
    }

    public set activeActs(value: Act[]) {
        this._activeActs = value;
    }
}